export default "__VITE_ASSET__09bb788f__"